const Book = ({ title, img, author }) => {
  return (
    <article className="book">
      <img alt="" src={img} />
      <h1>{title}</h1>
      <h4>{author}</h4>
    </article>
  );
};

export default Book;
